// extracted by mini-css-extract-plugin
export default {"container":"selector_container__2rE5W","icon":"selector_icon__SP+kV","select":"selector_select__jzhvM","label":"selector_label__76-OF","noBorder":"selector_noBorder__nkKR1"};